<section class="w-full">
    @if(view.site) {
    <div class="w-full relative h-[400px] bg-cover bg-no-repeat bg-center flex flex-col justify-center items-center"
        [ngStyle]="{ 'background-image': 'url(' + view.imageHref + ')' }">
        <!-- <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div> -->
        <h1 class="z-10 custom_font text-6xl text-white text-shadow">{{view.title}}</h1>
    </div>
    }
    <div class="px-0 dark:bg-gray-900" id="contact">
        <div class="px-6 py-8 sm:py-10 lg:px-8">
            <div class="mx-auto max-w-xl flex flex-col items-center justify-center text-center">
                <h1 class="text-4xl md:text-5xl font-bold tracking-tight text-gray-900">Let's Talk</h1>
                <p class="mt-3 text-lg text-gray-600">Have a question about our packages, a destination suggestion, or
                    special travel request?
                    Our team is here to help make your journey unforgettable.</p>
            </div>
            <form class="mx-auto mt-8 max-w-xl sm:mt-10">
                <div class="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                    <div>
                        <label for="first-name" class="block text-sm font-semibold leading-6 text-gray-900">First
                            name</label>
                        <div class="mt-2.5">
                            <input required="" type="text" name="first-name" id="first-name" autocomplete="given-name"
                                [(ngModel)]="view.message.firstName" placeholder="Your First Name"
                                class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
                        </div>
                    </div>
                    <div>
                        <label for="last-name" class="block text-sm font-semibold leading-6 text-gray-900">Last
                            name</label>
                        <div class="mt-2.5">
                            <input required="" type="text" name="last-name" id="last-name" autocomplete="family-name"
                                [(ngModel)]="view.message.lastName" placeholder="Your Last Name"
                                class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-500 sm:text-sm sm:leading-6">
                        </div>
                    </div>
                    <div class="sm:col-span-2">
                        <label for="email" class="block text-sm font-semibold leading-6 text-gray-900">Email</label>
                        <div class="mt-2.5">
                            <input required="" type="email" name="email" id="email" autocomplete="email"
                                [(ngModel)]="view.message.emailAddress" placeholder="Your Email Address"
                                class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-500 sm:text-sm sm:leading-6">
                        </div>
                    </div>
                    <div class="sm:col-span-2">
                        <label for="phone" class="block text-sm font-semibold leading-6 text-gray-900">Phone
                            number</label>
                        <div class="mt-2.5">
                            <input required="" type="tel" name="phone" id="phone" autocomplete="tel"
                                [(ngModel)]="view.message.phoneNumber" placeholder="Your Phone Number"
                                class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-500 sm:text-sm sm:leading-6">
                        </div>
                    </div>
                    <div class="sm:col-span-2">
                        <label for="message" class="block text-sm font-semibold leading-6 text-gray-900">Message</label>
                        <div class="mt-2.5">
                            <textarea name="message" id="message" rows="4" placeholder="Share your thoughts..."
                                [(ngModel)]="view.message.comments"
                                class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-500 sm:text-sm sm:leading-6"></textarea>
                        </div>
                    </div>
                </div>
                <div class="mt-10">
                    <button type="submit" [disabled]="!isFormValid()"
                        matTooltip="Complete all Fields to Send Message"
                        class="bg-primary-500 text-white rounded-sm py-2 w-full transition-opacity duration-300"
                        [class.cursor-not-allowed]="!isFormValid()">
                        <span class="flex items-center justify-center">
                            Submit
                            <mat-icon class="ml-2 icon-size-5 text-white" svgIcon="feather:send"></mat-icon>
                        </span>
                    </button>

                </div>

            </form>
        </div>

    </div>
</section>